import { render, staticRenderFns } from "./setTime.vue?vue&type=template&id=05cdbad1&"
import script from "./setTime.vue?vue&type=script&lang=js&"
export * from "./setTime.vue?vue&type=script&lang=js&"
import style0 from "./setTime.vue?vue&type=style&index=0&id=05cdbad1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports